export default {
  '@class': 'string',
  id: 'number',
  token: 'string',
  work: 'reference',
  work_offer: 'reference',
}
